// cSpell:ignore flexbox, STYuanti, vertical

import React from 'react';
import styled from 'styled-components';

import { Flex } from './static/style';
import { Node } from './static/json/constant';

export default class RowStar extends React.Component {

    render() {
        const { maxLength, star } = this.props;
        const starArr = new Array(maxLength).fill(0);

        return (
            <StarBox>
                {starArr && Array.isArray(starArr) && starArr.map((value, index) =>
                    this.props.type && this.props.type === Node.node_star
                        ? <NodeStar key={index} active={index < star ? true : false} />
                        : <Star key={index} active={index < star ? true : false} />)}
            </StarBox>
        );
    }
}

const StarBox = styled(Flex)`
    z-index: 1;
    justify-content: space-around;
    padding: 0 0.05rem;
    margin-bottom: 0.2rem;
`;

const Star = styled.div`
    width: 0.45rem;
    height: 0.45rem;
    background: url(${props => props.active ? require('./static/img/star-active.png') : require('./static/img/star-gray.png')}) no-repeat center;
    background-size: contain;
`;

const NodeStar = styled.div`
    width: 0.42rem;
    height: 0.42rem;
    background: url(${props => props.active ? require('./static/img/node-star-active.png') : require('./static/img/node-star-gray.png')}) no-repeat center;
    background-size: contain;
`;


// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/lesson-row-star.js